export default "__VITE_ASSET__Bz0Ie3bN__"